<template>
  <div class="index-ferie">
    <div class="WEB-title col-24 no-padding">
      <span class="appname">
        {{ $t('ferie.title').toUpperCase() }}
      </span>
    </div>

    <div class="WEB-content WEB-box-shadow col-24 no-padding">
      <keep-alive>
        <router-view class="contenuto" :tableHeight="contenitoreHeight - 40"></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contenitoreHeight: {
      type: Number
    }
  },
  name: 'IndexFerie',
  components: {/*HeaderApp*/ },
  /*watch: {
    '$mq.resize': 'setContenitoreHeight'
  },*/
  i18n: {
    messages: {
      it_IT: {
        ferie: {
          title: 'Ferie / Permessi',
        }
      },
      fr_FR: {
        ferie: {
          title: 'Demande de congé',
        }
      },
      es_ES: {
        ferie: {
          title: 'Solicitud de ausencia'
        }
      },
      de_DE: {
        ferie: {
          title: 'Freizeit',
        }
      },
      en_GB: {
        ferie: {
          title: 'Holiday',
        }
      }
    }
  },
  data() {
    return {
      //contenitoreHeight: 0,
      //tableHeight: 0,
      //counterNuovi: 0
    }
  },
  mounted: function () {
    // this.$router.push({name: 'HomePage'})
    // this.setContenitoreHeight()
  },
  methods: {
    /*setContenitoreHeight: function () {
      console.log('size')
      this.contenitoreHeight = window.innerHeight - 140
      this.tableHeight = this.contenitoreHeight - 155
    }*/
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.index-ferie {
  .box-centrale {
    width: 100%;
    float: left;
    padding-left: 15px;
    padding-right: 15px;
  }

  .set-font();
  height: 100%;

  .menu {
    float: left;
  }

  .language-modal {
    .elemento {
      font-size: 14px;
      margin-top: 5px;
      margin-bottom: 20px;

      .label {
        color: @greenRiva;
      }

      .radio {
        margin-top: 5px;
        color: @greenRiva;
      }

      .value {
        color: #bbbbbb;
      }

      .textarea:focus {
        border: 1px solid @greenRiva;
      }
    }
  }

  .titolo-app {
    padding-left: 5px;
    .set-font(@size: 15px; @color: @greenRiva);
    letter-spacing: 2px;
    overflow: hidden;
    height: 50px;
    line-height: 50px;

    .titolo-bold {
      font-weight: 700;
    }
  }

  .contenitore {
    -webkit-box-shadow: 0 0 10px 2px #cecece;
    -moz-box-shadow: 0 0 10px 2px #cecece;
    box-shadow: 0 0 10px 2px #cecece;
    background-color: #ffffff;
    margin: auto;
    //overflow-x: hidden;
    overflow: auto;
    text-align: center;

    .cat {
      cursor: pointer;

      img {
        cursor: pointer;
        margin-top: 10px;
        height: 65px;
        margin-bottom: 10px;
      }

      .didascaliaIcone {
        // width: 60%;
        word-wrap: break-word;
        margin-right: auto;
        margin-left: auto;
        color: #58585a;
        min-height: 50px;
        font-family: 'Roboto-Bold' !important;
        border-top: 1px solid orange;
        letter-spacing: 1px;
        text-transform: uppercase;
        cursor: pointer;
        padding-top: 10px;
      }

      .docToRead {
        position: relative;
        top: -5px;
        right: 0px;
        padding: 2px 6px;
        color: white;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Ferie/IndexFerie.vue